import { useCallback } from 'react';
import { useUpdateInboxFilterTagsMutation } from 'shared/hooks/queries/use-update-inbox-filter-tags-mutation';

export const useClearInboxFilters = () => {
  const { mutate: updateFilterTags } = useUpdateInboxFilterTagsMutation();

  return useCallback(() => updateFilterTags([]), [updateFilterTags]);
};
